import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';

import { VALIDATE_TIN, SET_TIN, RESET_TIN_INFO } from './constants';
import { setTIN, validateTIN, resetTINInfo } from './actions';

const TINNumberSelector = (state) => {
  return state.TINDetails;
};

export const useTIN = {
  state: () => {
    return useSelect(TINNumberSelector);
  },
  actions: () => {
    return {
      validateTIN: useAction(validateTIN, {
        saga: useAsync(VALIDATE_TIN),
      }),
      setTIN: useAction(setTIN, {
        saga: useAsync(SET_TIN),
      }),
      resetTINInfo: useAction(resetTINInfo, {
        saga: useAsync(RESET_TIN_INFO),
      }),
    };
  },
};
